module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_3-d40f40e50fafe7c8466e89a3822dec43.png";